import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VChip,{attrs:{"color":_vm.color,"small":_vm.small}},[_vm._v(" "+_vm._s(_vm.$t(_vm.lowerStatus))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }